import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import styles from './styles.less';

const PaymantLogo = ({ paymentMethod, footer }) => {
  const { t } = React.useContext(LocalizationContext);
  const paymentMethods = {
    arca: {
      style: 'ameriaImg',
      image: !footer
        ? '/static/images/course/ameria.png'
        : '/static/images/course/ameria_white.png',
      text: t('ameria.logo.text'),
    },
  };
  return (
    <>
      {paymentMethod && paymentMethods[paymentMethod] && (
        <div className={styles.ameriaComponent}>
          <span>{paymentMethods[paymentMethod].text}</span>
          <img
            className={styles[paymentMethods[paymentMethod].style]}
            src={paymentMethods[paymentMethod].image}
            alt={paymentMethod}
          />
        </div>
      )}
    </>
  );
};

PaymantLogo.propTypes = {
  paymentMethod: PropTypes.string.isRequired,
  footer: PropTypes.bool,
};

PaymantLogo.defaultProps = {
  footer: false,
};

export default PaymantLogo;
